import Head from 'next/head';
import Videos from '@/components/Videos';

const Page = () => {
  return (
    <>
      <Head>
        <title>Videos</title>
      </Head>

      <h1>Videos</h1>
      <p className="lead">
        Video sind in vier unterschiedlichen Seitenverhältnissen (Aspect ratio)
        verfügbar. <code>16:9</code>, <code>21:9</code>, <code>4:3</code> und{' '}
        <code>1:1</code>. Die <code>Aspect Ratio</code> <code>16:9</code> und{' '}
        <code>4:3</code> stellen die heute gängigsten Formate dar.
      </p>
      <Videos />
    </>
  );
};

export default Page;
